export default __webpack_public_path__ + "static/skibii-bd1196cd0e1b81180fe40c1386ec95f7.png";